import { t } from "i18next"
import { useUnit } from "effector-react"
import { Label, SelectDropDown, Typography } from "@callcenter/design-system"
import { $callcenterService, $themeService } from "@callcenter/effector-services"
import { ORIGINAL_INTERFACE_LANGUAGES, defineLanguageOptions } from "@callcenter/helpers"

import { userAccountModel } from "../../models"
import { INTERFACE_LANGUAGES } from "./interface-settings.constants"
import { UserThemeSettings } from "../user-theme-settings"
import { AgentWorkspaceLayoutSettings } from "../agent-workspace-layout-settings"

import mainStyles from "../../shared/styles.module.pcss"

export const InterfaceSettings = () => {
  const actions = useUnit({
    handleChange: userAccountModel.handleChange
  })

  const formValue = useUnit(userAccountModel.$formValue)
  const formErrors = useUnit(userAccountModel.$formErrors)
  const isCustomTheme = useUnit($themeService.$isCustomThemeSettingsAvailable)

  const interfaceLanguageOptions = defineLanguageOptions(INTERFACE_LANGUAGES, ORIGINAL_INTERFACE_LANGUAGES)

  const isLanguageSelectionAllowed = useUnit($callcenterService.$permissions).has("language_selection")
  const isAgentWorkspaceLayoutAllowed = useUnit(userAccountModel.$isAgentWorkspaceLayoutAllowed)
  const currentInterfaceLanguage = interfaceLanguageOptions.find(
    (language) => language.value === formValue.interface_language
  )

  const isSubmitPending = useUnit(userAccountModel.$isSubmitPending)

  return (
    <div className={mainStyles.selectSectionWrapper}>
      <Typography.Body1>
        {t("userProfile_userProfileSidePanel_sectionHeading_interfaceSettingsHeadLabel")}
      </Typography.Body1>
      {isLanguageSelectionAllowed && (
        <div>
          <SelectDropDown
            isDisabled={isSubmitPending}
            label={<Label label={t("userProfile_userProfileSidePanel_interfaceSettingsLabel_languageLabel")} />}
            value={currentInterfaceLanguage}
            options={interfaceLanguageOptions}
            isError={Boolean(formErrors.interface_language)}
            hint={formErrors.interface_language}
            onSelect={(option) => actions.handleChange({ name: "interface_language", value: option.value })}
          />
        </div>
      )}
      {isAgentWorkspaceLayoutAllowed && <AgentWorkspaceLayoutSettings />}
      {isCustomTheme && <UserThemeSettings />}
    </div>
  )
}
